module.exports = __webpack_public_path__ + "static/media/maze_screensaver.50e055c0.gif";